module.exports = __webpack_public_path__ + "img/ins-info-icon.6e80971b.svg";